<template>
  <div :class="`illustration-${orientation}`">
    <section class="parallax-wrap">
      <div class="viewport">
        <figure class="figure screen">
          <slot name="image"/>
        </figure>
      </div>
    </section>
  </div>
</template>

<script>
  export default {
    name: "ColImage",
    props: {
      orientation: {
        type: String,
        default: 'left'
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '../../assets/styles.scss';
  @import './feature-style.scss';
</style>